import 'reflect-metadata';
import { container, injectable } from 'tsyringe';
import { BackgroundController } from './background.controller';
import { BackgroundRegistry } from './bootstrap/background.registry';
import { LoggerService } from '../shared/services/logger.service';
import { ExternalServicesRegistry } from './bootstrap/external-services.registry';
import { ExternalServicesExposerService } from './services/external-services-exposer.service';
import { ConditionsRegistry } from './bootstrap/conditions-registry';
import { VendorRegistry } from './bootstrap/vendor.registry';
// NOTE(twolf): This exposes the dependency injection registries
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const registries = [
  new VendorRegistry(),
  new BackgroundRegistry(),
  new ExternalServicesRegistry(),
  new ConditionsRegistry(),
];

// -----------------------------------------------------------------------------
@injectable()
export class BackgroundBootstrap {
  // ---------------------------------------------------------------------------
  public constructor(
    private readonly backgroundController: BackgroundController,
    private readonly exposerService: ExternalServicesExposerService,
  ) {
    this.startup();
  }

  // ---------------------------------------------------------------------------
  private async startup() {
    // Sentry.initSentry();
    LoggerService.setup('Overwolf Promotions');
    // container.resolve(PatchesService);
    this.exposerService.initialize();
    this.backgroundController.run();
  }
}

container.resolve(BackgroundBootstrap);
